import React from "react";

export default function Dropdown({
  id,
  name,
  label,
  value,
  onChange,
  options,
  md
}) {
  return (
    <div className={`w-full p-2 ${md === 6 ? "md:w-1/2" : ""}`}>
      <label htmlFor={id} className="block text-sm font-medium text-gray-900">
        {label || (name ? name.charAt(0).toUpperCase() + name.slice(1) : "")}
      </label>
      <div className="relative mt-2">
        <select
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          className="block w-full rounded-md bg-white px-3 py-2 text-base text-gray-900 
                     outline outline-2 h-10 outline-indigo-300 placeholder-gray-400 
                     focus:outline-2 focus:outline-indigo-600 sm:text-sm"
        >
          <option value="" disabled>
            -- Select an option --
          </option>
          {options.map((option) => (
            <option key={option._id} value={option._id}>
              {option.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
